/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Box } from './box';
import styled from '@emotion/styled';
import ThreeDotsLoader from './three-dots-loader';
import theme from '../../constants/theme';
import SmallUnderlineLink from '../atoms/small-underline-link';
import { Link } from '../..';
const TextWrapper = styled(({ submitting, ...rest }) => jsx("div", Object.assign({}, rest))) `
  transition: opacity 0.2s linear;
  opacity: ${props => (props.submitting ? '0' : '1')};
`;
const LoaderWrapper = styled(({ submitting, ...rest }) => jsx("div", Object.assign({}, rest))) `
  position: absolute;
  align-items: center;
  justify-content: center;
  display: flex;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  transition: ${props => props.submitting
    ? ' opacity 0.5s 0.1s linear, visibility 0s 0s'
    : ' opacity 0.3s linear, visibility 0s 0.2s'};
  opacity: ${props => (props.submitting ? '1' : '0')};
  visibility: ${props => (props.submitting ? 'visible' : 'hidden')};
`;
function getHeightSize(size) {
    const buttonHeight = {
        s: '35px',
        m: '40px',
        l: '50px'
    };
    if (Array.isArray(size)) {
        const heightSize = size.map(iSize => buttonHeight[iSize]);
        return heightSize;
    }
    return buttonHeight[size];
}
export const Button = ({ children, component = 'button', display = 'flex', px = 'l', submitSuccess = false, submitting = false, variant = 'primary', width = 'auto', size = 'l', circular = false, onClick, href, target = {}, color = 'leafyGreen', ...rest }) => {
    let buttonComponent;
    const buttonOnClick = href ? {} : { onClick };
    /**
     * Below is a hack to allow for a special variant of Button
     * to render as an underline link for dealing with arrays
     * of button properties coming back from Sanity. This logic should be
     * moved into the website to improve.
     */
    if (variant === 'underlinedLink' || variant === 'underlinedLinkWhite') {
        buttonComponent = (jsx(SmallUnderlineLink, Object.assign({ display: display, color: variant === 'underlinedLinkWhite' ? 'white' : color }, buttonOnClick), children));
    }
    else {
        const variantObj = theme.buttons[variant];
        const colorVariant = variantObj.color;
        const heightPx = getHeightSize(size);
        const widthPx = circular ? heightPx : width;
        const paddingX = circular ? 'none' : px;
        buttonComponent = (jsx(Box, Object.assign({ component: href ? 'span' : component, variant: `buttons.${variant}` }, buttonOnClick, { sx: {
                cursor: submitting || submitSuccess ? 'auto' : 'pointer',
                position: 'relative',
                px: paddingX,
                transform: 'translate3d(0,0,0)',
                width: widthPx,
                whiteSpace: 'nowrap',
                height: heightPx,
                lineHeight: heightPx,
                display,
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                transition: 'all 0.2s linear',
                fontWeight: 'bold',
                fontSize: variantObj.fontSize,
                fontFamily: 'primary',
                py: 'none',
                textDecoration: 'none',
                svg: {
                    fill: colorVariant,
                    '&:hover': {
                        fill: colorVariant
                    }
                },
                '&:focus': {
                    outline: 'none',
                    boxShadow: '0 0 0 3px rgba(112, 134, 128, 0.4)'
                },
                '&:disabled': {
                    cursor: 'not-allowed'
                }
            } }, rest),
            jsx(TextWrapper, { submitting: submitting }, children),
            jsx(LoaderWrapper, { submitting: submitting },
                jsx(ThreeDotsLoader, { color: colorVariant }))));
    }
    return href ? (jsx(Link, Object.assign({ href: href, noUnderline: true, useButtonOutline: !variant.includes('underlinedLink'), onClick: onClick }, target), buttonComponent)) : (buttonComponent);
};
//# sourceMappingURL=button.js.map